import React from "react";
import Modal from "@/ui/Modal/Modal";
import Button from "@/ui/Button/Button";
import Typography from "@/ui/Typography/Typography";
import { useTranslation } from "react-i18next";
import cls from "./styles.module.scss";

interface DeletePaymentMethodModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeletePaymentMethodModal({
  isOpen,
  onCancel,
  onConfirm,
}: DeletePaymentMethodModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className={cls.deleteModal}>
        <Typography className={cls.deleteModalTitle}>
          {t("paymentOptions.deleteConfirmTitle")}
        </Typography>
        <div className={cls.deleteModalActions}>
          <Button
            className={cls.cancelBtn}
            variant="outlined"
            onClick={onCancel}
            label={t("common.cancel")}
          />
          <Button onClick={onConfirm} label={t("common.delete")} />
        </div>
      </div>
    </Modal>
  );
}
